/* Beyond Radix · combined template: "2 kits" = this kit + a kit of the shopper's choice.
   Layers on br-pdp.js (which still handles "1 kit" and "2 of the same kit"). */
(function () {
  'use strict';
  if (window.__brCombo) return;
  window.__brCombo = true;

  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents, format) {
    format = (format || '${{amount}}').replace(/<[^>]*>/g, '');
    var m = format.match(/\{\{\s*(\w+)\s*\}\}/);
    var n = function (prec, th, dec) {
      var parts = (cents / 100).toFixed(prec).split('.');
      return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, th) + (parts[1] ? dec + parts[1] : '');
    };
    var map = {
      amount: function () { return n(2, ',', '.'); },
      amount_no_decimals: function () { return n(0, ',', '.'); },
      amount_with_comma_separator: function () { return n(2, '.', ','); },
      amount_no_decimals_with_comma_separator: function () { return n(0, '.', ','); },
      amount_with_apostrophe_separator: function () { return n(2, "'", '.'); },
      amount_with_space_separator: function () { return n(2, ' ', ','); }
    };
    return m ? format.replace(m[0], (map[m[1]] || map.amount)()) : format;
  }

  function init(section) {
    var pair = $('[data-br-pair]', section);
    var form = $('[data-br-form]', section);
    if (!pair || !form || section.__brPaired) return;
    section.__brPaired = true;

    var variants = [];
    try { variants = JSON.parse($('[data-br-variants]', section).textContent); } catch (e) {}
    var fmt = '${{amount}}';
    try { fmt = JSON.parse($('[data-br-money-format]', section).textContent); } catch (e) {}
    var idInput = $('[data-br-variant-id]', form);
    var atc = $('[data-br-atc]', form);
    var errorEl = $('[data-br-error]', form);
    var dyn = $('[data-br-dynamic]', section);
    var buyPair = $('[data-br-buy-pair]', section);
    var sum = $('[data-br-pair-sum]', pair);
    var title = ($('.br-buy__title', section) || {}).textContent || '';

    function current() {
      var id = String(idInput.value);
      return variants.filter(function (v) { return String(v.id) === id; })[0] || variants[0];
    }
    function bundleTwo() {
      var r = $('[data-br-bundle] input[type="radio"]:checked', section);
      return r && r.value === '2';
    }
    function choice() { return $('[data-br-pair-opt]:checked', pair); }
    function otherKit() {
      var c = choice();
      return bundleTwo() && c && !c.dataset.same ? c : null;
    }

    function paint() {
      var two = bundleTwo();
      pair.hidden = !two;
      var v = current();
      var c = choice();
      var other = otherKit();
      var samePrice = $('[data-br-pair-same-price]', pair);
      if (samePrice && v) samePrice.textContent = '+' + v.price;
      if (other && v) {
        var total = money(v.cents + Number(other.dataset.cents), fmt);
        $$('[data-br-btn-total]', section).forEach(function (el) { el.textContent = total; });
        $$('[data-br-price-2]', section).forEach(function (el) { el.textContent = total; });
        if (sum) sum.textContent = title.trim() + ' + ' + other.dataset.title + ' = ' + total;
      } else if (two && v) {
        $$('[data-br-price-2]', section).forEach(function (el) { el.textContent = v.price2; });
        $$('[data-br-btn-total]', section).forEach(function (el) { el.textContent = v.price2; });
        if (sum) sum.textContent = c ? '2 × ' + title.trim() + ' = ' + v.price2 : '';
      } else if (v) {
        $$('[data-br-price-2]', section).forEach(function (el) { el.textContent = v.price2; });
      }
      if (dyn) dyn.classList.toggle('br-is-paired', !!other);
      if (buyPair) buyPair.hidden = !other || (v && v.preorder);
    }

    section.addEventListener('change', function (e) {
      if (e.target.matches('[data-br-bundle] input, [data-br-pair-opt], [data-br-variant-select]')) setTimeout(paint, 0);
    });
    paint();

    function addPair(goCheckout, btn) {
      var other = otherKit();
      var v = current();
      if (!other || !v) return;
      errorEl.hidden = true;
      var busy = btn || atc;
      busy.classList.add('is-loading');
      atc.classList.add('is-loading');
      var props = {};
      $$('input[name^="properties["]:not(:disabled)', form).forEach(function (el) {
        props[el.name.slice(11, -1)] = el.value;
      });
      var body = { items: [
        { id: Number(v.id), quantity: 1, properties: props },
        { id: Number(other.value), quantity: 1 }
      ] };
      var cart = goCheckout ? null : (document.querySelector('cart-notification') || document.querySelector('cart-drawer'));
      if (cart && typeof cart.getSectionsToRender === 'function') {
        body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
        body.sections_url = window.location.pathname;
        if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
      }
      var url = ((window.routes && window.routes.cart_add_url) || '/cart/add').replace(/\.js$/, '') + '.js';
      fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) {
            errorEl.textContent = res.description || res.message || 'Something went wrong. Please try again.';
            errorEl.hidden = false;
            return;
          }
          if (goCheckout) { window.location.href = '/checkout'; return; }
          if (res.items && res.items.length) { res.key = res.items[0].key; res.id = res.items[0].id; res.variant_id = res.items[0].variant_id; }
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'br-combo', productVariantId: v.id, cartData: res });
          }
          if (cart && typeof cart.renderContents === 'function') {
            cart.classList.remove('is-empty');
            cart.renderContents(res);
          } else {
            window.location.href = (window.routes && window.routes.cart_url) || '/cart';
            return;
          }
          atc.classList.add('is-added');
          setTimeout(function () { atc.classList.remove('is-added'); }, 1600);
        })
        .catch(function () {
          errorEl.textContent = 'We could not reach the cart. Check your connection and try again.';
          errorEl.hidden = false;
        })
        .finally(function () {
          busy.classList.remove('is-loading');
          atc.classList.remove('is-loading');
        });
    }

    // Runs before br-pdp's own submit handler; only takes over when a different second kit is chosen.
    document.addEventListener('submit', function (e) {
      if (e.target !== form || !otherKit()) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      if (atc.disabled || atc.classList.contains('is-loading')) return;
      addPair(false);
    }, true);

    if (buyPair) buyPair.addEventListener('click', function () {
      if (buyPair.classList.contains('is-loading')) return;
      addPair(true, buyPair);
    });
  }

  function boot(scope) { $$('[data-br-product]', scope).forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();


/* Beyond Radix · combined template: video, starting-point finder, motion */
(function () {
  'use strict';
  if (window.__brComboFx) return;
  window.__brComboFx = true;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Video: build the player only when asked (no third-party load before play) */
  function embedUrl(u) {
    var m = u.match(/(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/|shorts\/))([\w-]{6,})/);
    if (m) return 'https://www.youtube-nocookie.com/embed/' + m[1] + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
    m = u.match(/vimeo\.com\/(?:video\/)?(\d+)/);
    if (m) return 'https://player.vimeo.com/video/' + m[1] + '?autoplay=1&title=0&byline=0';
    return null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-br-video-play]');
    if (!btn) return;
    var frame = btn.closest('[data-br-video]');
    var src = frame.dataset.src || '';
    var url = embedUrl(src);
    var el;
    if (url) {
      el = document.createElement('iframe');
      el.src = url; el.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; el.allowFullscreen = true;
      el.title = btn.getAttribute('aria-label') || 'Video';
    } else if (/\.(mp4|webm|mov)(\?|$)/i.test(src)) {
      el = document.createElement('video');
      el.src = src; el.controls = true; el.autoplay = true; el.playsInline = true;
    } else { window.open(src, '_blank', 'noopener'); return; }
    el.className = 'br-cvid__player';
    frame.appendChild(el);
    frame.classList.add('is-playing');
  });

  /* Starting-point finder: light the program path from the matching phase */
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.br-finder [role="radio"]');
    if (!chip) return;
    setTimeout(function () {
      var box = chip.closest('.br-finder');
      var items = $$('.br-finder__path li', box);
      if (!items.length) return;
      var on = chip.getAttribute('aria-checked') === 'true';
      var tip = (chip.dataset.tip || '').toLowerCase();
      var start = -1;
      if (on) {
        items.forEach(function (li, k) { if (start < 0 && li.dataset.title && tip.indexOf(li.dataset.title) > -1) start = k; });
        if (start < 0) { var n = tip.match(/phase\s*0?(\d+)/); start = n ? Math.max(0, Math.min(items.length - 1, Number(n[1]) - 1)) : 0; }
      }
      items.forEach(function (li, k) {
        li.classList.toggle('is-start', on && k === start);
        li.classList.toggle('is-after', on && k > start);
        li.style.setProperty('--d', (on ? Math.max(0, k - start) * 90 : 0) + 'ms');
      });
      box.classList.toggle('has-pick', on);
    }, 0);
  });

  /* Stagger children that enter together */
  function stagger(scope) {
    $$('.br-out__item, .br-crev__card, .br-finder__chip, .br-tool, .br-plus__item, .br-doc, .br-kit, .br-phase', scope).forEach(function (el, k) {
      if (!el.style.getPropertyValue('--i')) el.style.setProperty('--i', (k % 6) + 1);
    });
  }
  /* Reveal (works with br-pdp's .br-reveal; also covers elements added here) */
  function reveal(scope) {
    if (reduce || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-in'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -10% 0px' });
    $$('.br-fx', scope).forEach(function (el) { io.observe(el); });
  }
  function boot(scope) { stagger(scope); reveal(scope); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();


/* Sticky bar: sit above Shopify's preview bar when it is showing */
(function () {
  function lift() {
    var s = document.querySelector('[data-br-sticky]');
    if (!s) return;
    var bar = document.getElementById('PBarNextFrameWrapper');
    var h = bar ? bar.getBoundingClientRect().height : 0;
    s.style.bottom = h > 0 ? (h + 12) + 'px' : '';
    if (bar && window.ResizeObserver && !bar.__brWatched) { bar.__brWatched = true; new ResizeObserver(lift).observe(bar); }
  }
  window.addEventListener('load', function () { lift(); setTimeout(lift, 2000); });
  window.addEventListener('resize', lift);
})();


/* Sticky bar: scroll fallback so it always appears once the main button is out of view */
(function () {
  function sync() {
    var s = document.querySelector('[data-br-sticky]');
    var a = document.querySelector('[data-br-atc]');
    if (!s || !a) return;
    var show = a.getBoundingClientRect().bottom < 0;
    if (s.classList.contains('is-visible') === show) return;
    s.classList.toggle('is-visible', show);
    s.setAttribute('aria-hidden', show ? 'false' : 'true');
    var b = s.querySelector('[data-br-submit]');
    if (b) b.tabIndex = show ? 0 : -1;
  }
  window.addEventListener('scroll', sync, { passive: true });
  window.addEventListener('load', sync);
})();


/* Slim header once the page is scrolled */
(function () {
  var root = document.documentElement, on = false;
  function check() {
    var s = window.scrollY > 120;
    if (s !== on) { on = s; root.classList.toggle('br-head-slim', s); }
  }
  window.addEventListener('scroll', check, { passive: true });
  check();
})();


/* Headings rise word by word; Included cards get a shine layer */
(function () {
  if (window.__brSplit) return;
  window.__brSplit = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function split(h) {
    if (h.classList.contains('br-split')) return;
    var n = 0, walker = document.createTreeWalker(h, NodeFilter.SHOW_TEXT), nodes = [], t;
    while ((t = walker.nextNode())) nodes.push(t);
    nodes.forEach(function (node) {
      var mark = node.parentNode.closest && node.parentNode.closest('.br-mark');
      if (mark) { if (!mark.classList.contains('br-w')) { mark.classList.add('br-w'); mark.style.setProperty('--wi', n++); } return; }
      var parts = node.textContent.split(/(\s+)/), frag = document.createDocumentFragment();
      parts.forEach(function (p) {
        if (!p) return;
        if (/^\s+$/.test(p)) { frag.appendChild(document.createTextNode(p)); return; }
        var s = document.createElement('span'); s.className = 'br-w'; s.style.setProperty('--wi', n++); s.textContent = p; frag.appendChild(s);
      });
      node.parentNode.replaceChild(frag, node);
    });
    h.style.setProperty('--wn', n);
    h.classList.add('br-split');
  }
  function showVisible(hs) {
    hs.forEach(function (h) { if (h.classList.contains('is-shown')) return; var r = h.getBoundingClientRect(); if (r.top < innerHeight * 0.95 && r.bottom > 0) h.classList.add('is-shown'); });
  }
  function boot(scope) {
    scope.querySelectorAll('.br-plus__item').forEach(function (c) {
      if (!c.querySelector('.br-plus__shine')) { var s = document.createElement('span'); s.className = 'br-plus__shine'; s.setAttribute('aria-hidden', 'true'); c.appendChild(s); }
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    var hs = Array.prototype.slice.call(scope.querySelectorAll('.br-h2'));
    var io = new IntersectionObserver(function (en) {
      en.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('is-shown'); io.unobserve(x.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    hs.forEach(function (h) { split(h); io.observe(h); });
    window.addEventListener('scroll', function () { showVisible(hs); }, { passive: true });
    setTimeout(function () { showVisible(hs); }, 900);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(document); });
  else boot(document);
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();


/* Keep a highlighted word and the punctuation after it on one line */
(function () {
  function glue() {
    document.querySelectorAll('.br-split .br-mark').forEach(function (m) {
      var n = m.nextSibling;
      if (!n || m.parentNode.classList.contains('br-nowrap')) return;
      var punct = n.nodeType === 1 && n.classList.contains('br-w') && /^[.,!?;:]+$/.test(n.textContent);
      var textPunct = n.nodeType === 3 && /^[.,!?;:]+/.test(n.textContent);
      if (!punct && !textPunct) return;
      var w = document.createElement('span'); w.className = 'br-nowrap';
      m.parentNode.insertBefore(w, m); w.appendChild(m); w.appendChild(n);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { setTimeout(glue, 0); });
  else setTimeout(glue, 0);
})();


/* Inside the box: the stage shows the chosen tool and plays through them until a visitor picks one */
(function () {
  function init(tray) {
    if (tray.__brStage) return; tray.__brStage = true;
    var stage = tray.querySelector('[data-br-stage]');
    var num = tray.querySelector('[data-br-stage-num]');
    var cap = tray.querySelector('.br-tray__caption');
    var btns = Array.prototype.slice.call(tray.querySelectorAll('.br-tool__btn'));
    if (!stage || !btns.length) return;
    var current = 0, timer = null, user = false, visible = false;
    function show(i, fromUser) {
      var b = btns[i]; if (!b) return;
      current = i;
      btns.forEach(function (x) { var on = x === b; x.classList.toggle('is-active', on); x.setAttribute('aria-pressed', on ? 'true' : 'false'); });
      var img = b.querySelector('.br-tool__img');
      if (img) { stage.innerHTML = img.innerHTML; stage.classList.remove('is-swap'); void stage.offsetWidth; stage.classList.add('is-swap'); }
      if (num) num.textContent = i + 1;
      var n = tray.querySelector('[data-br-tray-name]'), t = tray.querySelector('[data-br-tray-text]'), g = tray.querySelector('[data-br-tray-tag]');
      if (n) n.textContent = (b.getAttribute('data-name') || '') + '.';
      if (t) t.textContent = b.getAttribute('data-text') || '';
      if (g) { g.textContent = b.getAttribute('data-tag') || ''; g.hidden = !g.textContent; }
      if (cap) { cap.classList.remove('is-swap'); void cap.offsetWidth; cap.classList.add('is-swap'); }
      if (fromUser) {
        var list = b.closest('.br-tray__grid');
        if (list && list.scrollWidth > list.clientWidth) {
          var li = b.parentElement; list.scrollTo({ left: li.offsetLeft - (list.clientWidth - li.offsetWidth) / 2, behavior: 'smooth' });
        }
      }
    }
    function stop() { user = true; if (timer) { clearInterval(timer); timer = null; } }
    function play() {
      if (user || timer || !visible) return;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
      timer = setInterval(function () { show((current + 1) % btns.length, false); }, 3200);
    }
    btns.forEach(function (b, i) {
      b.addEventListener('click', function () { stop(); show(i, true); });
      b.addEventListener('mouseenter', function () { if (window.matchMedia('(hover: hover)').matches) { stop(); show(i, false); } });
      b.addEventListener('focus', function () { stop(); show(i, false); });
    });
    tray.addEventListener('touchstart', stop, { passive: true });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { visible = e.isIntersecting; if (visible) play(); else if (timer) { clearInterval(timer); timer = null; } });
      }, { threshold: 0.35 }).observe(tray);
    } else { visible = true; play(); }
  }
  function run() { document.querySelectorAll('[data-br-stage-tray]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* How it works: steps light up in order, then the program bar fills phase by phase */
(function () {
  function run() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-br-flow]'));
    if (!els.length) return;
    function playVisible() {
      els.forEach(function (el) {
        if (el.classList.contains('is-play')) return;
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight * 0.85 && r.bottom > 0) el.classList.add('is-play');
      });
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-play'); io.unobserve(e.target); } });
      }, { threshold: 0.2 });
      els.forEach(function (el) { io.observe(el); });
    }
    window.addEventListener('scroll', playVisible, { passive: true });
    playVisible();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* Product photos: tap to open a full-screen viewer with arrows, swipe, thumbnails and Esc to close */
(function () {
  function icon(d) { return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' + d + '</svg>'; }
  function bestSrc(img) {
    var set = img.getAttribute('srcset');
    if (set) {
      var best = null, bw = 0;
      set.split(',').forEach(function (p) { var b = p.trim().split(/\s+/), w = parseInt(b[1], 10) || 0; if (w >= bw) { bw = w; best = b[0]; } });
      if (best) return best;
    }
    return img.currentSrc || img.src;
  }
  function init(gallery) {
    if (gallery.__brLb) return; gallery.__brLb = true;
    var slides = Array.prototype.slice.call(gallery.querySelectorAll('[data-br-slide]'));
    var imgs = slides.map(function (s) { return s.querySelector('img'); });
    var list = imgs.map(function (im, i) { return im && slides[i].getAttribute('data-media-type') === 'image' ? { src: bestSrc(im), alt: im.alt || '', thumb: im.currentSrc || im.src, slide: i } : null; }).filter(Boolean);
    if (!list.length) return;
    var stage = gallery.querySelector('.br-gallery__stage');
    if (stage && !stage.querySelector('.br-gallery__zoom')) {
      var z = document.createElement('button');
      z.type = 'button'; z.className = 'br-gallery__zoom'; z.setAttribute('aria-label', 'Open photo full screen');
      z.innerHTML = icon('<path d="M15 3h6v6M9 21H3v-6M21 3l-7 7M3 21l7-7"/>');
      stage.appendChild(z);
      z.addEventListener('click', function () { var a = gallery.querySelector('[data-br-slide].is-active'); open(Math.max(0, slides.indexOf(a))); });
    }
    var lb = null, cur = 0, img, count, thumbs;
    function build() {
      lb = document.createElement('div');
      lb.className = 'br-lb'; lb.setAttribute('role', 'dialog'); lb.setAttribute('aria-modal', 'true'); lb.setAttribute('aria-label', 'Product photos');
      lb.innerHTML = '<div class="br-lb__bar"><span class="br-lb__count"></span><button type="button" class="br-lb__btn br-lb__close" aria-label="Close">' + icon('<path d="M6 6l12 12M18 6 6 18"/>') + '</button></div>' +
        '<div class="br-lb__stage"><img class="br-lb__img" alt=""><button type="button" class="br-lb__btn br-lb__nav br-lb__nav--prev" aria-label="Previous photo">' + icon('<path d="m15 6-6 6 6 6"/>') + '</button><button type="button" class="br-lb__btn br-lb__nav br-lb__nav--next" aria-label="Next photo">' + icon('<path d="m9 6 6 6-6 6"/>') + '</button></div>' +
        '<div class="br-lb__thumbs"></div>';
      document.body.appendChild(lb);
      img = lb.querySelector('.br-lb__img'); count = lb.querySelector('.br-lb__count'); thumbs = lb.querySelector('.br-lb__thumbs');
      list.forEach(function (it, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Photo ' + (i + 1));
        b.innerHTML = '<img src="' + it.thumb + '" alt="" loading="lazy">';
        b.addEventListener('click', function () { show(i); });
        thumbs.appendChild(b);
      });
      lb.querySelector('.br-lb__close').addEventListener('click', close);
      lb.querySelector('.br-lb__nav--prev').addEventListener('click', function () { show(cur - 1); });
      lb.querySelector('.br-lb__nav--next').addEventListener('click', function () { show(cur + 1); });
      lb.querySelector('.br-lb__stage').addEventListener('click', function (e) { if (e.target === e.currentTarget) close(); });
      var sx = null;
      lb.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      lb.addEventListener('touchend', function (e) { if (sx === null) return; var dx = e.changedTouches[0].clientX - sx; if (Math.abs(dx) > 40) show(cur + (dx < 0 ? 1 : -1)); sx = null; });
      document.addEventListener('keydown', function (e) {
        if (!lb.classList.contains('is-open')) return;
        if (e.key === 'Escape') close(); else if (e.key === 'ArrowRight') show(cur + 1); else if (e.key === 'ArrowLeft') show(cur - 1);
      });
    }
    function show(i) {
      cur = (i + list.length) % list.length;
      img.classList.remove('is-in'); void img.offsetWidth;
      img.src = list[cur].src; img.alt = list[cur].alt; img.classList.add('is-in');
      count.textContent = (cur + 1) + ' / ' + list.length;
      Array.prototype.forEach.call(thumbs.children, function (b, k) { b.classList.toggle('is-active', k === cur); if (k === cur) b.scrollIntoView({ block: 'nearest', inline: 'center' }); });
    }
    var opener = null;
    function open(slideIndex) {
      if (!lb) build();
      opener = document.activeElement;
      var k = 0; list.forEach(function (it, i) { if (it.slide === slideIndex) k = i; });
      document.documentElement.classList.add('br-lb-open');
      lb.classList.add('is-open'); show(k);
      lb.querySelector('.br-lb__close').focus();
    }
    function close() {
      lb.classList.remove('is-open'); document.documentElement.classList.remove('br-lb-open');
      if (opener && opener.focus) opener.focus();
    }
    slides.forEach(function (s, i) {
      var im = s.querySelector('img'); if (!im || s.getAttribute('data-media-type') !== 'image') return;
      im.addEventListener('click', function () { open(i); });
    });
  }
  function run() { document.querySelectorAll('[data-br-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* Product photos: the thumb strip follows the photo on screen (swipe, arrows or dots) */
(function () {
  function init(g) {
    var strip = g.querySelector('.br-gallery__thumbs');
    if (!strip || strip.__brSync) return; strip.__brSync = true;
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-br-slide]'));
    function sync() {
      var i = -1;
      slides.forEach(function (s, k) { if (s.classList.contains('is-active')) i = k; });
      if (i < 0) return;
      var thumbs = Array.prototype.slice.call(strip.querySelectorAll('.br-thumb'));
      var on = null;
      thumbs.forEach(function (b) {
        var hit = parseInt(b.getAttribute('data-br-goto'), 10) === i;
        b.classList.toggle('is-active', hit);
        b.setAttribute('aria-selected', hit ? 'true' : 'false');
        if (hit) on = b;
      });
      if (on && strip.scrollWidth > strip.clientWidth + 2) {
        var r = on.getBoundingClientRect(), sr = strip.getBoundingClientRect();
        var left = strip.scrollLeft + (r.left - sr.left) - (strip.clientWidth - r.width) / 2;
        strip.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
      }
    }
    var mo = new MutationObserver(function () { setTimeout(sync, 0); });
    slides.forEach(function (s) { mo.observe(s, { attributes: true, attributeFilter: ['class'] }); });
    sync();
  }
  function run() { document.querySelectorAll('[data-br-gallery]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* Designed-by line: Dr. Vinit's photo and Dr. Patel's initials in round frames */
(function () {
  function run() {
    var f = document.querySelector('.br-proof .br-faces'); if (!f || f.__br) return; f.__br = true;
    var s = f.children;
    if (s[0] && !s[0].querySelector('img')) s[0].innerHTML = '<img src="/cdn/shop/files/ChatGPT_Image_Aug_18_2026_06_45_44_PM.png?width=160" alt="Dr. Vinit K. Dubey" width="80" height="80" loading="lazy">';
    if (s[1] && !s[1].textContent.trim() && !s[1].querySelector('img')) { s[1].textContent = 'DP'; s[1].setAttribute('aria-label', 'Dr. Deepak V. Patel'); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* Pre-order card and sticky bar: show the saving */
(function () {
  function money(n, like) { var cur = (like || '').replace(/[\d.,\s]/g, '') || '$'; return cur + n.toFixed(2); }
  function num(t) { return parseFloat(String(t || '').replace(/[^\d.]/g, '')); }
  function run() {
    var st = document.querySelector('.br-sticky__meta');
    var nowEl = st && st.querySelector('span > span'), wasEl = st && st.querySelector('s');
    var now = nowEl ? num(nowEl.textContent) : NaN, was = wasEl ? num(wasEl.textContent) : NaN;
    if (!(was > now)) return;
    var pct = Math.round((1 - now / was) * 100), off = was - now;
    if (wasEl && !st.querySelector('.br-sticky__save')) {
      var sv = document.createElement('span'); sv.className = 'br-sticky__save'; sv.textContent = '-' + pct + '%';
      wasEl.parentNode.insertBefore(sv, wasEl.nextSibling);
    }
    var res = document.querySelector('.br-reserve');
    if (res && !res.querySelector('.br-reserve__deal')) {
      var d = document.createElement('div'); d.className = 'br-reserve__deal';
      d.innerHTML = '<span class="br-reserve__deal-tag">Save ' + pct + '%</span><span class="br-reserve__deal-text">Pre-order price <b>' + nowEl.textContent.trim() + '</b><s>' + wasEl.textContent.trim() + '</s> · you save <b>' + money(off, nowEl.textContent) + '</b></span>';
      var top = res.querySelector('.br-reserve__top');
      res.insertBefore(d, top ? top.nextSibling : res.firstChild);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();


/* Reviews: swipe, plus a gentle auto-advance that pauses while someone is touching or hovering */
(function () {
  function init(track) {
    if (track.__brAuto) return; track.__brAuto = true;
    var cards = Array.prototype.slice.call(track.children);
    if (cards.length < 2) return;
    var dots = document.createElement('div'); dots.className = 'br-crev-dots'; dots.setAttribute('aria-hidden', 'true');
    cards.forEach(function (c, i) { var b = document.createElement('button'); b.type = 'button'; b.tabIndex = -1; b.addEventListener('click', function () { go(i); hold(); }); dots.appendChild(b); });
    (track.closest('.br-crev__car') || track).insertAdjacentElement('afterend', dots);
    function pad() { return parseFloat(getComputedStyle(track).paddingLeft) || 0; }
    function index() {
      var x = track.scrollLeft, best = 0, d = 1e9;
      cards.forEach(function (c, i) { var dd = Math.abs(c.offsetLeft - track.offsetLeft - pad() - x); if (dd < d) { d = dd; best = i; } });
      if (track.scrollLeft >= track.scrollWidth - track.clientWidth - 4) best = cards.length - 1;
      return best;
    }
    function paint() { var k = index(); Array.prototype.forEach.call(dots.children, function (b, i) { b.classList.toggle('is-on', i === k); }); dots.style.display = track.scrollWidth > track.clientWidth + 4 ? '' : 'none'; }
    function go(i) { var c = cards[(i + cards.length) % cards.length]; track.scrollTo({ left: c.offsetLeft - track.offsetLeft - pad(), behavior: 'smooth' }); }
    var paused = false, visible = false, timer = null, resumeAt = 0;
    function hold() { resumeAt = Date.now() + 6000; }
    function tick() {
      if (paused || !visible || Date.now() < resumeAt || document.hidden) return;
      if (track.scrollWidth <= track.clientWidth + 4) return;
      var atEnd = track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
      go(atEnd ? 0 : index() + 1);
    }
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches) timer = setInterval(tick, 4200);
    track.addEventListener('pointerdown', function () { paused = true; hold(); }, { passive: true });
    track.addEventListener('pointerup', function () { paused = false; hold(); }, { passive: true });
    track.addEventListener('touchstart', function () { paused = true; hold(); }, { passive: true });
    track.addEventListener('touchend', function () { paused = false; hold(); }, { passive: true });
    track.addEventListener('mouseenter', function () { paused = true; });
    track.addEventListener('mouseleave', function () { paused = false; });
    track.addEventListener('focusin', function () { paused = true; });
    track.addEventListener('focusout', function () { paused = false; });
    var ticking = false;
    track.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(function () { ticking = false; paint(); }); } }, { passive: true });
    if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { visible = es[0].isIntersecting; }, { threshold: .4 }).observe(track); else visible = true;
    window.addEventListener('resize', paint);
    paint();
  }
  function run() { document.querySelectorAll('.br-crev__track').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();

/* What's inside: load a sharp photo in the big circle (it copies the small thumbnail's size hint otherwise) */
(function () {
  function fix() {
    document.querySelectorAll('.br-stage__disc img').forEach(function (i) {
      if (i.getAttribute('sizes') !== '400px') i.setAttribute('sizes', '400px');
      if (i.getAttribute('loading') === 'lazy') i.setAttribute('loading', 'eager');
    });
  }
  function init() {
    fix();
    document.querySelectorAll('.br-stage__disc').forEach(function (d) {
      new MutationObserver(fix).observe(d, { childList: true, subtree: true, attributes: true, attributeFilter: ['src', 'srcset', 'sizes'] });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
